(function () {
  'use strict';

  angular.module('ringbaPortal').component('campaignCallAnalysis', {
    bindings: {
      currentCampaign: '<',
      campaignForm: '<',
      formDisabled: '<',
      pricingPlan: '<'
    },
    controller: CampaignCallAnalysisController,
    controllerAs: 'vm',
    templateUrl: '/scripts/components/campaigns/campaign-call-analysis.component.html'
  });

  // Per person per account, as the voice-response node's fee acceptance is stored.
  const CALL_ANALYSIS_CONSENT_KEY = 'callAnalysisConsentAcknowledged';
  const RATE_FRACTION_DIGITS = 3;
  const DEFAULT_DAILY_CAP_CALLS = 20000;

  function CampaignCallAnalysisController(
    $scope,
    $filter,
    $uibModal,
    systemFlagsService,
    userSettingsService,
    accountsService
  ) {
    'ngInject';

    const vm = this;
    vm.$onInit = onInit;
    vm.$onChanges = onChanges;

    vm.isVisible = false;
    vm.isAdmin = false;
    vm.formattedRate = '';
    vm.costPreview = '';
    vm.onCallAnalysisToggled = onCallAnalysisToggled;
    vm.onDailyCapToggled = onDailyCapToggled;
    vm.confirmPricing = confirmPricing;
    vm.cancelPricing = cancelPricing;

    function onInit() {
      // The dashboard state resolves only once the flags have settled.
      vm.isVisible = systemFlagsService.values.callAnalysis;

      if (!vm.isVisible) {
        return;
      }

      vm.isAdmin = accountsService.isAdmin();

      $scope.$watch(_currentDailyCap, _updateCostPreview);

      if (vm.isAdmin) {
        _loadPricingAcceptance();
      }
    }

    function onChanges(changes) {
      if (changes.pricingPlan) {
        _applyRate();
      }
    }

    function onCallAnalysisToggled(isUserToggle) {
      const setting = vm.currentCampaign.callAnalysisSettings;

      // The model also moves when a campaign arrives with the setting on, and that asks for nothing.
      if (!isUserToggle || !setting.isEnabled || vm.hasAcceptedPricing) {
        return;
      }

      // The toggle reports the model after it has moved, so it goes back until the pricing is confirmed.
      setting.isEnabled = false;

      vm.pricingModal = $uibModal.open({
        templateUrl: '/scripts/components/campaigns/call-analysis-pricing.modal.html',
        scope: $scope,
        controllerAs: 'vm',
        size: 'md'
      });
    }

    function confirmPricing() {
      vm.hasAcceptedPricing = true;
      vm.currentCampaign.callAnalysisSettings.isEnabled = true;

      _closePricingModal();
      _recordPricingAcceptance();
    }

    function cancelPricing() {
      _closePricingModal();
    }

    function onDailyCapToggled() {
      const setting = vm.currentCampaign.callAnalysisSettings;

      // The cap keeps its value while switched off, so only a campaign that has never
      // had one is offered the default.
      if (setting.isDailyCapEnabled && setting.dailyCapInCalls == null) {
        setting.dailyCapInCalls = DEFAULT_DAILY_CAP_CALLS;
      }
    }

    function _closePricingModal() {
      if (vm.pricingModal) {
        vm.pricingModal.close();
        vm.pricingModal = null;
      }
    }

    function _loadPricingAcceptance() {
      // Acceptance that cannot be read counts as not accepted, so the charge is stated again.
      vm.hasAcceptedPricing = false;

      return userSettingsService.getUserSettings()
        .then(function (userSettings) {
          const accepted = userSettings[CALL_ANALYSIS_CONSENT_KEY];

          vm.hasAcceptedPricing = !!(accepted && accepted[accountsService.currentAccountId]);
        })
        .catch(angular.noop);
    }

    function _recordPricingAcceptance() {
      return userSettingsService.getUserSettings()
        .then(function (userSettings) {
          if (!userSettings[CALL_ANALYSIS_CONSENT_KEY]) {
            userSettings[CALL_ANALYSIS_CONSENT_KEY] = {};
          }

          userSettings[CALL_ANALYSIS_CONSENT_KEY][accountsService.currentAccountId] = true;

          return userSettingsService.saveUserSettings(userSettings);
        })
        .catch(angular.noop);
    }

    function _applyRate() {
      // The rate is an extra, so one that cannot be read leaves the controls working without it.
      const rate = parseFloat(vm.pricingPlan && vm.pricingPlan.callAnalysisCost);

      vm.rate = isNaN(rate) ? null : rate;
      vm.formattedRate = vm.rate == null ? '' : $filter('currency')(vm.rate, undefined, RATE_FRACTION_DIGITS);
      _updateCostPreview();
    }

    function _currentDailyCap() {
      const setting = vm.currentCampaign && vm.currentCampaign.callAnalysisSettings;

      return setting ? setting.dailyCapInCalls : undefined;
    }

    function _updateCostPreview() {
      const cap = _currentDailyCap();

      if (vm.rate == null || !angular.isNumber(cap) || !isFinite(cap)) {
        vm.costPreview = '';
        return;
      }

      vm.costPreview = $filter('translate')('CAMPAIGN_CALL_ANALYSIS_COST_PREVIEW', {
        cap: $filter('number')(cap),
        rate: vm.formattedRate,
        total: $filter('currency')(cap * vm.rate)
      });
    }
  }
})();
